// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ErrorBoundaryJs from "./ErrorBoundary.js";

var make = ErrorBoundaryJs.ErrorBoundary;

export {
  make ,
}
/* make Not a pure module */
